import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replace',
})
export class ReplacePipe implements PipeTransform {
  constructor() {}

  transform(
    value: string,
    options: { searchValue: string | RegExp; replaceValue: string }
  ): string {
    return value.replace(options.searchValue, options.replaceValue);
  }
}
